import locale from "common/managers/locale";
import functions from "common/helper/functions";
import "common/widgets/Link/Link";
const DFSelectionView = kendo.ui.Widget.extend({
    options: {
        name: "DFSelectionView",
        //Reference to grid widget this selection view is for
        grid: null
    },

    init: function() {
        kendo.ui.Widget.fn.init.apply(this, arguments);

        this._toggleView = $.proxy(this._toggleView, this);

        //limiting click event for toggleView for accessibility purposes. this prevents holding the enter key and causing the grid to "flash".
        this.link = $("<a data-role='link' tabindex='0'>").on("click", functions.limit(this._toggleView, 500)).appendTo(this.element);
        kendo.bind(this.link);
        this._update = $.proxy(this._update, this);
        this._grid().checkTracker.bind("change", this._update);
        this._update();
    },

    destroy: function() {
        kendo.ui.Widget.fn.destroy.apply(this, arguments);
        this.element.empty();
        delete this.fullDataSource;
        delete this.link;
    },

    _grid: function() {
        return this.options.grid;
    },

    _update: function() {
        if (this._showingAll) {
            var count = this._grid().checkTracker.getSelectedCount();
            this.element.addClass("selectionCount").removeClass("selectionViewAll");
            if (count) {
                this.link.text(locale.get("assign.showSome", count));
                this.element.css("visibility", "visible");
            } else {
                this.element.css("visibility", "hidden");
            }
        } else {
            this.link.text(locale.get("assign.show"));
            this.element.addClass("selectionViewAll").removeClass("selectionCount");
            this.element.css("visibility", "visible");
        }
    },

    showingAll: function() {
        return this._showingAll;
    },

    _showingAll: true,

    reset: function() {
        if (!this._showingAll) {
            this._toggleView();
        }
    },

    showAll: function(showAll) {
        var grid = this._grid();
        if (!showAll) {
            this.fullDataSource = grid.dataSource;
            var ds = new kendo.data.DataSource({
                data: this._grid().checkTracker.getSelected(),
                schema: {
                    model: this.fullDataSource.reader.model
                }
            });
            this._showingAll = false;
            grid.setDataSource(ds);
            if (!grid.options.autoBind) {
                ds.fetch();
            }
        } else {
            if (this.fullDataSource) {
                grid.checkTracker.updateCurrent(this.fullDataSource);
                var before = grid.options.autoBind;
                grid.options.autoBind = false;
                grid.setDataSource(this.fullDataSource);
                grid.options.autoBind = before;
                delete this.fullDataSource;
            }
            this._showingAll = true;
            grid.refresh();
        }
        this._update();
    },

    _toggleView: function(e) {
        if (this._showingAll) {
            this.showAll(false)
        } else {
            this.showAll(true);
        }
        e && e.preventDefault();
    }
});
export default DFSelectionView;
